module.exports = __webpack_public_path__ + "static/media/coliseum.f7251b3e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/coliseum.jpg
 ** module id = 426
 ** module chunks = 0
 **/